// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__3Omyz","header":"MessagesList_header__UWQEK","chat":"MessagesList_chat___TSTK"};